/*
 * Copyright (c) 2025 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

export type ScreenPermit = (typeof SCREEN_PERMITS_LIST)[number];
export type FeaturePermit = (typeof FEATURE_PERMITS_LIST)[number];
export type ActionPermit = (typeof ACTION_PERMITS_LIST)[number];
export type Permit = ScreenPermit | FeaturePermit | ActionPermit;

export const SCREEN_PERMITS_LIST = [
    'DOCUMENT_PICTURE_SCREEN',
    'USER_SETTINGS_INFO_SCREEN',
    'USER_SETTINGS_SECURITY_SCREEN',
    'ADMIN_USERS_LIST_SCREEN',
    'INSPECTOR_HOME_SCREEN',
    'TAXPAYER_HOME_SCREEN',
    'OPERATOR_HOME_SCREEN',
    'INFOGRAPHICS_FIN_SCREEN',
    'INFOGRAPHICS_TECH_SCREEN',
    'REGIONAL_INSPECTOR_INFOGRAPHICS_SCREEN',
    'CENTRAL_INSPECTOR_INFOGRAPHICS_SCREEN',
    'STATISTICS_SCREEN',
    'CENTRAL_INSPECTOR_STATISTICS_SCREEN',
    'ALERTS_LIST_SCREEN',
    'ALERT_DETAILS_SCREEN',
    'ALERTS_SETTINGS_SCREEN',
    'ALERT_EXECUTION_LOGS_SCREEN',
    'ALERT_RULES_SCREEN',
    'REPORTS_SCREEN',
    'STORES_MAP_SCREEN',
    'CASHBOXES_MAP_SCREEN',
    'OPERATORS_LIST_SCREEN',
    'OPERATOR_CARD_SCREEN',
    'COMPANIES_LIST_SCREEN',
    'COMPANY_CARD_SCREEN',
    'STORES_LIST_SCREEN',
    'STORE_CARD_SCREEN',
    'CASHBOXES_LIST_SCREEN',
    'CASHBOX_CARD_SCREEN',
    'DOCUMENTS_LIST_SCREEN',
    'DOCUMENT_CARD_SCREEN',
    'DOCUMENT_CARD_PICT_SCREEN',
    'DEVICES_LIST_SCREEN',
    'DEVICE_CARD_SCREEN',
    'CASHREGISTER_MODELS_LIST_SCREEN',
    'CASHREGISTER_MODEL_CARD_SCREEN',
    'SERVICE_SCREEN',
    'REGISTRY_WRAPPER',
    'MAPS_WRAPPER',
    'INFOGRAPHICS_WRAPPER',
] as const;

export const FEATURE_PERMITS_LIST = [
    'CASHBOX_ERRORS',
    'CASHBOX_LAST_AUDIT_DATE',
    'CASHBOX_STATUS_COMMENT',
    'CASHBOX_TURNOVERS',
    'CASHBOX_DOCUMENTS',
    'CASHBOX_LAST_DOCUMENT',
    'CASHBOX_MODE_HISTORY',
    'CASHBOX_STATUS_HISTORY',
    'CASHBOX_REPLACEMENT',
    'CASHBOX_CLOCK_STATUS_HISTORY',
    'CASHBOX_AUDIT_HISTORY',
    'CASHBOX_ALERTS_HISTORY',
    'CASHBOX_GPS_TRACKING',
    'CASHBOX_CHECKSUM_HISTORY',
    'CASHBOX_SERVICE',
    'CASHBOX_PERIOD_FILTERS',
    'CASHREGISTER_OS_AND_SOFTWARE_VERSION',
    'CASHREGISTER_SOFTWARE_VERSIONS_FILTER',
    'DEVICE_NUMBER_AND_VERSIONS',
    'STORE_TAX_AUTHORITY',
    'STORE_ACTIVITY',
    'AI_CLASSIFICATION',
    'COMPANY_NUMBER_NAME_STATUS',
    'COMPANY_TAXATION_TYPE',
    'OPERATOR_NAME',
    'OPERATOR_TAX_NUMBER',
    'DOCUMENT_ID',
] as const;

export const ACTION_PERMITS_LIST = ['CHANGE_CASHBOX_STATUS_ACTION', 'EDIT_ERP_POS_INTEGRATION_STATUS_ACTION'] as const;
